import { z } from "zod";

export const EditTraineeSchema = z.object({
  full_name: z.string(),
  email: z.string().email("Enter a valid email"),
  phone_number: z.string(),
  whatsapp_number: z.string(),
  date_of_birth: z.string(),
  gender: z.string(),
  building_name: z.string(),
  landmark: z.string(),
  district: z.string(),
  city: z.string(),
  state: z.string(),
  postal_code: z.string(),
  training_program: z.string(),
  preferred_time: z.string(),
  preferred_training_date: z.string().optional(),
});

export type EditSchemaFormData = z.infer<typeof EditTraineeSchema>;
